import { render } from "./FileManagerThumbnail.vue?vue&type=template&id=f3ebdbc2&scoped=true"
import script from "./FileManagerThumbnail.vue?vue&type=script&lang=js"
export * from "./FileManagerThumbnail.vue?vue&type=script&lang=js"

import "./FileManagerThumbnail.vue?vue&type=style&index=0&id=f3ebdbc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ebdbc2"]])

export default __exports__